import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react'; // tslint:disable-line
import { EconomiesProvider as Provider } from '@shapeable/ui';
import { Economy } from '@shapeable/copper-connect-types';
import { shapeableProviderValue } from '@shapeable/gatsby-theme-shapeable-web/src/components/providers/provider-value';

const ECONOMIES_QUERY = graphql`
query NodeAllEconomiesQuery {
  allShapeableCollectionRecord(filter: { collectionKey: { eq: "Economies" } }) {
    nodes {
      data
    }
  }
}
`;

export const EconomiesProvider: React.FC<any> = ({ children }) => {
  const economies: Economy[] = shapeableProviderValue(useStaticQuery(ECONOMIES_QUERY), 'items');
  const value = (economies || []).filter((economy) => !!economy.depositsCount);
  return <Provider value={value}>{children}</Provider>;
};
